__webpack_require__.p = "/kr/ko/customer-service/returns-claims/spareparts/";